var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9184 2.09L13.1935 19.514L10.2438 12.672L9.96866 12.034L9.33029 11.759L2.48431 8.822L18.4546 2.651L19.9184 2.09ZM20.6889 0C20.5238 0 20.3697 0.033 20.2156 0.088L0.844361 7.568C0.161965 7.832 -0.168227 8.591 0.0849202 9.273C0.216997 9.603 0.470144 9.867 0.789329 10.01L8.61487 13.376L11.9938 21.208C12.214 21.703 12.6982 22 13.2045 22C13.3806 22 13.5567 21.967 13.7218 21.89C14.052 21.747 14.3052 21.483 14.4373 21.153L21.9106 1.793C22.1747 1.111 21.8335 0.352 21.1511 0.088C21.0191 0.033 20.854 2.15166e-08 20.6889 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7a233e660cdbbd6ad174d39dce238e32.svg";
export { ForwardRef as ReactComponent };